import { ChampionshipError } from '../../../endpoint/championships/championship-error';
import { ChampionshipsEndpoints } from '../../../endpoint';
import { Models } from '../../../';
import { DateTimeISO8601 } from '../../../mappers/backend-types/common.types';

interface CreateChampionship {
  mainContentId: Models.OppositionId;
  datetimeStart: DateTimeISO8601;
  datetimeFinish: DateTimeISO8601;
}

interface CreateChampionshipResponse {
  id: Models.ChampionshipId;
}

export const createChampionship = async (params: CreateChampionship): Promise<CreateChampionshipResponse> => {
  try {
    const { mainContentId, datetimeStart, datetimeFinish } = params;
    return await ChampionshipsEndpoints.createChampionship({ mainContentId, datetimeStart, datetimeFinish });
  } catch (error) {
    const errorBody: ChampionshipError.ErrorWrapper = (error as any).error;
    throw errorBody;
  }
};
